import { useId } from 'react';

import { cn } from '@upcaret/ui';

type CentlyWordmarkProps = {
  className?: string;
};

export function CentlyWordmark({ className }: CentlyWordmarkProps) {
  const clipPathId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-10 33 136 43"
      role="img"
      aria-label="Cently"
      className={cn(
        'inline-block h-[1em] w-auto align-[-0.12em] text-primary',
        className,
      )}
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect x="23" y="0" width="200" height="100" />
        </clipPath>
      </defs>

      <g clipPath={`url(#${clipPathId})`}>
        <path
          fill="currentColor"
          d="m9.563443 70.67764l0 -4.5625q-4.015625 -0.765625 -6.1875 -3.703125q-2.171875 -2.953125 -2.171875 -7.59375q0 -4.65625 2.1875 -7.609375q2.203125 -2.96875 6.171875 -3.703125l0 -4.5625l4.6875 0l0 4.515625q2.609376 0.4375 4.265626 1.8125q1.671875 1.359375 2.609375 3.40625l-4.53125 2.46875q-0.421875 -0.9375 -1.078126 -1.703125q-0.65625 -0.765625 -1.640625 -1.15625l0 13.09375q1.109375 -0.375 1.84375 -1.15625q0.75000095 -0.796875 1.265626 -1.78125l4.484375 2.515625q-0.984375 2.046875 -2.765625 3.4375q-1.765625 1.375 -4.453126 1.765625l0 4.515625l-4.6875 0zm-2.34375 -14.078125q0 1.71875 0.703125 2.9375q0.703125 1.203125 2.0625 1.765625l0 -12.96875q-1.359375 0.546875 -2.0625 1.765625q-0.703125 1.21875 -0.703125 2.921875l0 3.578125zm28.061844 9.734375q-2.5625 0 -4.562498 -0.828125q-2.0 -0.84375 -3.390625 -2.359375q-1.390625 -1.515625 -2.09375 -3.6875q-0.703125 -2.171875 -0.703125 -4.859375q0 -2.640625 0.6875 -4.796875q0.6875 -2.15625 2.03125 -3.6875q1.34375 -1.546875 3.296875 -2.375q1.9687481 -0.828125 4.484373 -0.828125q2.765625 0 4.75 0.9375q1.984375 0.9375 3.234375 2.515625q1.265625 1.578125 1.84375 3.65625q0.578125 2.0625 0.578125 4.328125l0 1.875l-14.374998 0l0 0.34375q0 2.21875 1.1874981 3.515625q1.203125 1.296875 3.765625 1.296875q1.953125 0 3.1875 -0.78125q1.25 -0.796875 2.3125 -1.90625l3.15625 3.921875q-1.5 1.75 -3.90625 2.734375q-2.40625 0.984375 -5.484375 0.984375zm-0.125 -18.765625q-1.921875 0 -3.015625 1.265625q-1.0781231 1.25 -1.0781231 3.328125l0 0.34375l7.843748 0l0 -0.375q0 -2.046875 -0.921875 -3.296875q-0.90625 -1.265625 -2.828125 -1.265625zm14.754028 18.25l0 -22.390625l6.3125 0l0 3.796875l0.265625 0q0.59375 -1.75 2.078125 -3.03125q1.5 -1.28125 4.140625 -1.28125q3.4531288 0 5.218754 2.3125q1.78125 2.296875 1.78125 6.5625l0 14.03125l-6.312504 0l0 -13.515625q0 -2.1875 -0.6875 -3.21875q-0.671875 -1.046875 -2.421875 -1.046875q-0.765625 0 -1.5 0.1875q-0.71875 0.1875 -1.296875 0.625q-0.578125 0.421875 -0.921875 1.046875q-0.34375 0.609375 -0.34375 1.421875l0 14.5l-6.3125 0zm33.28246 0q-3.296875 0 -4.984375 -1.65625q-1.671875 -1.671875 -1.671875 -4.875l0 -10.953125l-3.15625 0l0 -4.90625l1.578125 0q1.28125 0 1.75 -0.609375q0.46875 -0.625 0.46875 -1.78125l0 -3.671875l5.671875 0l0 6.0625l4.4375 0l0 4.90625l-4.4375 0l0 12.578125l4.09375 0l0 4.90625l-3.75 0zm14.759186 0q-3.25 0 -4.765625 -1.578125q-1.515625 -1.578125 -1.515625 -4.5625l0 -25.421875l6.3125 0l0 26.65625l2.828125 0l0 4.90625l-2.859375 0zm20.090698 -22.390625l5.875 0l-8.609375 25.84375q-0.859375 2.609375 -2.421875 3.84375q-1.546875 1.234375 -4.453125 1.234375l-3.921875 0l0 -4.90625l4.234375 0l0.765625 -2.46875l-7.859375 -23.546875l6.28125 0l3.28125 10.453125l1.625 6.484375l0.25 0l1.65625 -6.484375l3.296875 -10.453125z"
          fillRule="nonzero"
        />
      </g>

      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="11"
        d="M72.6 27.4a32 32 0 1 0 0 45.2M50 3v94"
        transform="translate(-8 35) scale(0.4)"
      />
    </svg>
  );
}
